// Auto-generated from BMS_Data_Final_27032026.xlsx — do not edit manually
// Generated on: 2026-04-07T01:04:03.530Z
export const projectHistoryData = [
  {
    "id": 1,
    "dateTime": "27-03-2026 12:00:00",
    "eventDescription": "Batch DBSQC25001 status: Closed",
    "projectStatus": "Confirmed",
    "campaignStatus": "Completed",
    "batchStatus": "Closed",
    "organization": "Sai Life Sciences",
    "role": "Production Manager",
    "username": "production@sailifesciences.com"
  },
  {
    "id": 2,
    "dateTime": "27-03-2026 12:00:00",
    "eventDescription": "Batch DBSQC26001 status: Closed",
    "projectStatus": "Confirmed",
    "campaignStatus": "Completed",
    "batchStatus": "Closed",
    "organization": "Sai Life Sciences",
    "role": "Production Manager",
    "username": "production@sailifesciences.com"
  },
  {
    "id": 3,
    "dateTime": "27-03-2026 12:00:00",
    "eventDescription": "Batch DBSQC26002 status: Cancelled",
    "projectStatus": "On-Hold",
    "campaignStatus": "Completed",
    "batchStatus": "Cancelled",
    "organization": "Sai Life Sciences",
    "role": "Production Manager",
    "username": "production@sailifesciences.com"
  },
  {
    "id": 4,
    "dateTime": "27-03-2026 12:00:00",
    "eventDescription": "Batch DBSQC26003 status: Closed",
    "projectStatus": "Confirmed",
    "campaignStatus": "Completed",
    "batchStatus": "Closed",
    "organization": "Sai Life Sciences",
    "role": "Production Manager",
    "username": "production@sailifesciences.com"
  },
  {
    "id": 5,
    "dateTime": "27-03-2026 12:00:00",
    "eventDescription": "Batch DBSQC26004 status: Closed",
    "projectStatus": "Confirmed",
    "campaignStatus": "Completed",
    "batchStatus": "Closed",
    "organization": "Sai Life Sciences",
    "role": "Production Manager",
    "username": "production@sailifesciences.com"
  },
  {
    "id": 6,
    "dateTime": "27-03-2026 12:00:00",
    "eventDescription": "Batch DBSQC26005 status: Closed",
    "projectStatus": "Confirmed",
    "campaignStatus": "Completed",
    "batchStatus": "Closed",
    "organization": "Sai Life Sciences",
    "role": "Production Manager",
    "username": "production@sailifesciences.com"
  },
  {
    "id": 7,
    "dateTime": "27-03-2026 12:00:00",
    "eventDescription": "Batch DBSQC26006 status: Closed",
    "projectStatus": "Confirmed",
    "campaignStatus": "Completed",
    "batchStatus": "Closed",
    "organization": "Sai Life Sciences",
    "role": "Production Manager",
    "username": "production@sailifesciences.com"
  },
  {
    "id": 8,
    "dateTime": "27-03-2026 12:00:00",
    "eventDescription": "Batch DBSQC26007 status: Closed",
    "projectStatus": "Confirmed",
    "campaignStatus": "Completed",
    "batchStatus": "Closed",
    "organization": "Sai Life Sciences",
    "role": "Production Manager",
    "username": "production@sailifesciences.com"
  },
  {
    "id": 9,
    "dateTime": "27-03-2026 12:00:00",
    "eventDescription": "Batch DBSQC26008 status: Closed",
    "projectStatus": "Confirmed",
    "campaignStatus": "Completed",
    "batchStatus": "Closed",
    "organization": "Sai Life Sciences",
    "role": "Production Manager",
    "username": "production@sailifesciences.com"
  },
  {
    "id": 10,
    "dateTime": "27-03-2026 12:00:00",
    "eventDescription": "Batch DBSQC26009 status: Closed",
    "projectStatus": "Confirmed",
    "campaignStatus": "Completed",
    "batchStatus": "Closed",
    "organization": "Sai Life Sciences",
    "role": "Production Manager",
    "username": "production@sailifesciences.com"
  },
  {
    "id": 11,
    "dateTime": "27-03-2026 12:00:00",
    "eventDescription": "Batch DBSQC26010 status: Closed",
    "projectStatus": "Confirmed",
    "campaignStatus": "Completed",
    "batchStatus": "Closed",
    "organization": "Sai Life Sciences",
    "role": "Production Manager",
    "username": "production@sailifesciences.com"
  },
  {
    "id": 12,
    "dateTime": "27-03-2026 12:00:00",
    "eventDescription": "Batch DBSQC26011 status: Closed",
    "projectStatus": "Confirmed",
    "campaignStatus": "Completed",
    "batchStatus": "Closed",
    "organization": "Sai Life Sciences",
    "role": "Production Manager",
    "username": "production@sailifesciences.com"
  },
  {
    "id": 13,
    "dateTime": "27-03-2026 12:00:00",
    "eventDescription": "Batch DBSQC26012 status: For Confirmation",
    "projectStatus": "Confirmed",
    "campaignStatus": "In-Progress",
    "batchStatus": "For Confirmation",
    "organization": "Sai Life Sciences",
    "role": "Production Manager",
    "username": "production@sailifesciences.com"
  },
  {
    "id": 14,
    "dateTime": "16-JAN-2026 22:59:33",
    "eventDescription": "Batch DBSQC25001 manufactured. Yield: 47.7%. Produced: 81.1 Kg",
    "projectStatus": "Confirmed",
    "campaignStatus": "In-Progress",
    "batchStatus": "Manufactured",
    "organization": "Sai Life Sciences",
    "role": "Production Manager",
    "username": "production@sailifesciences.com"
  },
  {
    "id": 15,
    "dateTime": "16-FEB-2026 14:06:42",
    "eventDescription": "Batch DBSQC26001 manufactured. Yield: 59.9%. Produced: 233.46 Kg",
    "projectStatus": "Confirmed",
    "campaignStatus": "In-Progress",
    "batchStatus": "Manufactured",
    "organization": "Sai Life Sciences",
    "role": "Production Manager",
    "username": "production@sailifesciences.com"
  },
  {
    "id": 17,
    "dateTime": "28-FEB-2026 11:05:23",
    "eventDescription": "Batch DBSQC26003 manufactured. Yield: 57.4%. Produced: 57.36 Kg",
    "projectStatus": "Confirmed",
    "campaignStatus": "In-Progress",
    "batchStatus": "Manufactured",
    "organization": "Sai Life Sciences",
    "role": "Production Manager",
    "username": "production@sailifesciences.com"
  },
  {
    "id": 18,
    "dateTime": "28-FEB-2026 05:04:42",
    "eventDescription": "Batch DBSQC26004 manufactured. Yield: 55.2%. Produced: 110.48 Kg",
    "projectStatus": "Confirmed",
    "campaignStatus": "In-Progress",
    "batchStatus": "Manufactured",
    "organization": "Sai Life Sciences",
    "role": "Production Manager",
    "username": "production@sailifesciences.com"
  },
  {
    "id": 19,
    "dateTime": "02-MAR-2026 20:01:42",
    "eventDescription": "Batch DBSQC26005 manufactured. Yield: 60.8%. Produced: 60.76 Kg",
    "projectStatus": "Confirmed",
    "campaignStatus": "In-Progress",
    "batchStatus": "Manufactured",
    "organization": "Sai Life Sciences",
    "role": "Production Manager",
    "username": "production@sailifesciences.com"
  },
  {
    "id": 20,
    "dateTime": "08-MAR-2026 15:44:41",
    "eventDescription": "Batch DBSQC26006 manufactured. Yield: 55.3%. Produced: 110.6 Kg",
    "projectStatus": "Confirmed",
    "campaignStatus": "In-Progress",
    "batchStatus": "Manufactured",
    "organization": "Sai Life Sciences",
    "role": "Production Manager",
    "username": "production@sailifesciences.com"
  },
  {
    "id": 21,
    "dateTime": "08-MAR-2026 03:57:53",
    "eventDescription": "Batch DBSQC26007 manufactured. Yield: 55.1%. Produced: 55.08 Kg",
    "projectStatus": "Confirmed",
    "campaignStatus": "In-Progress",
    "batchStatus": "Manufactured",
    "organization": "Sai Life Sciences",
    "role": "Production Manager",
    "username": "production@sailifesciences.com"
  },
  {
    "id": 22,
    "dateTime": "12-MAR-2026 17:15:42",
    "eventDescription": "Batch DBSQC26008 manufactured. Yield: 52.8%. Produced: 190.02 Kg",
    "projectStatus": "Confirmed",
    "campaignStatus": "In-Progress",
    "batchStatus": "Manufactured",
    "organization": "Sai Life Sciences",
    "role": "Production Manager",
    "username": "production@sailifesciences.com"
  },
  {
    "id": 23,
    "dateTime": "17-MAR-2026 02:36:28",
    "eventDescription": "Batch DBSQC26009 manufactured. Yield: 54.7%. Produced: 120.44 Kg",
    "projectStatus": "Confirmed",
    "campaignStatus": "In-Progress",
    "batchStatus": "Manufactured",
    "organization": "Sai Life Sciences",
    "role": "Production Manager",
    "username": "production@sailifesciences.com"
  },
  {
    "id": 24,
    "dateTime": "20-MAR-2026 22:49:13",
    "eventDescription": "Batch DBSQC26010 manufactured. Yield: 54.1%. Produced: 205.7 Kg",
    "projectStatus": "Confirmed",
    "campaignStatus": "In-Progress",
    "batchStatus": "Manufactured",
    "organization": "Sai Life Sciences",
    "role": "Production Manager",
    "username": "production@sailifesciences.com"
  },
  {
    "id": 25,
    "dateTime": "24-MAR-2026 07:14:56",
    "eventDescription": "Batch DBSQC26011 manufactured. Yield: 58.2%. Produced: 128.02 Kg",
    "projectStatus": "Confirmed",
    "campaignStatus": "In-Progress",
    "batchStatus": "Manufactured",
    "organization": "Sai Life Sciences",
    "role": "Production Manager",
    "username": "production@sailifesciences.com"
  },
  {
    "id": 26,
    "dateTime": "26-MAR-2026 15:20:25",
    "eventDescription": "Batch DBSQC26012 manufactured. Yield: 54.9%. Produced: 112.54 Kg",
    "projectStatus": "Confirmed",
    "campaignStatus": "In-Progress",
    "batchStatus": "Manufactured",
    "organization": "Sai Life Sciences",
    "role": "Production Manager",
    "username": "production@sailifesciences.com"
  }
];

// Project details data
export const projectDetails = {
  "projectId": "13762",
  "poNumber": "18219",
  "mbrNumber": "MBPR-BSQC-001",
  "productDescription": "4-(Aminomethyl)-6-bromophthalazin-1(2H)-one (BSQ Stage-C)",
  "cmoSite": "Sai Life Sciences - Unit-IV",
  "batchNumbers": "DBSQC25001, DBSQC26001, DBSQC26002, DBSQC26003, DBSQC26004, DBSQC26005, DBSQC26006, DBSQC26007, DBSQC26008, DBSQC26009, DBSQC26010, DBSQC26011, DBSQC26012",
  "deliveryNumber": "CMPO04BRS729"
};
